import {FixedIndicator} from '@app/types';

import apis, {getTokenFromLocalStorage} from './Apis';

const NemesisApi = apis.injectEndpoints({
  endpoints: (builder) => ({
    getFixedIndicators: builder.query<FixedIndicator[], void>({
      query: () => ({
        url: `nemesis/pilotage/fixed-indicators`,
        headers: {
          Authorization: `Bearer ${getTokenFromLocalStorage()}`,
        },
      }),
      providesTags: ['FixedIndicators'],
    }),
  }),
});

export const {useGetFixedIndicatorsQuery} = NemesisApi;
